var _path, _line, _line2, _line3, _rect, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _g4, _g5, _g6, _g7, _g8, _circle, _circle2, _circle3, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumbers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 760,
    height: 401,
    viewBox: "0 0 760 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.868 316.87C679.868 151.258 545.612 17.0024 380 17.0024C214.388 17.0024 80.1326 151.258 80.1326 316.87",
    stroke: "#A7CEFC",
    strokeWidth: 2,
    strokeDasharray: "15 15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78.5071,
    y1: 315.37,
    x2: 679.867,
    y2: 315.37,
    stroke: "#A7CEFC",
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200.81,
    y1: 75.4512,
    x2: 326.771,
    y2: 250.983,
    stroke: "#A7CEFC",
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 581.47,
    y1: 94.4168,
    x2: 456.752,
    y2: 251.976,
    stroke: "#A7CEFC",
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 324.615,
    y: 250.107,
    width: 133.525,
    height: 133.525,
    rx: 8.5,
    stroke: "#A7CEFC",
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.745,
    y: 276.238,
    width: 81.2649,
    height: 81.2649,
    rx: 10,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 276.238,
    width: 81.2649,
    height: 81.2649,
    rx: 10,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3097 319.999C77.9196 319.999 77.5295 319.85 77.2324 319.552C76.6374 318.957 76.6374 317.993 77.2324 317.398L87.1068 307.523C87.7011 306.928 88.6671 306.928 89.2614 307.523C89.8564 308.118 89.8564 309.083 89.2614 309.678L79.3869 319.552C79.0898 319.85 78.6997 319.999 78.3097 319.999V319.999Z",
    fill: "#FFE492"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3091 319.999C77.9191 319.999 77.5297 319.851 77.2319 319.553L72.2539 314.575C71.6589 313.98 71.6589 313.016 72.2539 312.421C72.8481 311.826 73.8134 311.826 74.4084 312.421L79.3864 317.398C79.9814 317.993 79.9814 318.958 79.3864 319.553C79.0893 319.851 78.6992 319.999 78.3091 319.999V319.999Z",
    fill: "#FFE492"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.131 335.865C79.9725 335.865 79.8118 335.84 79.6533 335.788C69.9137 332.576 63.3701 323.526 63.3701 313.269C63.3701 312.428 64.0527 311.746 64.8938 311.746C65.7349 311.746 66.4175 312.428 66.4175 313.269C66.4175 322.207 72.1201 330.094 80.6079 332.894C81.4071 333.158 81.8414 334.019 81.5778 334.818C81.3667 335.459 80.771 335.865 80.131 335.865V335.865Z",
    fill: "#FFE492"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8938 314.793C64.0527 314.793 63.3701 314.111 63.3701 313.27V302.49C63.3701 301.649 64.0527 300.966 64.8938 300.966C65.7349 300.966 66.4176 301.649 66.4176 302.49V313.27C66.4176 314.111 65.7349 314.793 64.8938 314.793Z",
    fill: "#FFE492"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8945 304.014C64.1463 304.014 63.4934 303.462 63.3868 302.7C63.271 301.866 63.8523 301.097 64.6865 300.981C69.8336 300.266 74.8017 298.727 79.4536 296.409C80.2071 296.034 81.1221 296.34 81.4969 297.093C81.8725 297.847 81.5655 298.761 80.8128 299.137C75.8645 301.602 70.5802 303.238 65.1055 304C65.0347 304.009 64.9638 304.014 64.8945 304.014V304.014Z",
    fill: "#FFE492"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1325 335.866C79.4933 335.866 78.8968 335.459 78.6857 334.819C78.4221 334.02 78.8564 333.158 79.6556 332.894C88.1434 330.095 93.846 322.208 93.846 313.27C93.846 312.428 94.5286 311.746 95.3697 311.746C96.2108 311.746 96.8934 312.428 96.8934 313.27C96.8934 323.526 90.3498 332.576 80.6094 335.789C80.451 335.841 80.291 335.866 80.1325 335.866V335.866Z",
    fill: "#FFE492"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3704 314.793C94.5293 314.793 93.8467 314.111 93.8467 313.27V302.49C93.8467 301.649 94.5293 300.966 95.3704 300.966C96.2115 300.966 96.8941 301.649 96.8941 302.49V313.27C96.8941 314.111 96.2115 314.793 95.3704 314.793Z",
    fill: "#FFE492"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3719 304.014C95.3018 304.014 95.2309 304.009 95.1601 304C89.6854 303.238 84.4011 301.602 79.4529 299.137C78.7002 298.761 78.3931 297.847 78.7687 297.093C79.1436 296.34 80.0585 296.034 80.812 296.409C85.4639 298.727 90.432 300.266 95.5791 300.981C96.4126 301.097 96.9947 301.867 96.8788 302.7C96.7737 303.462 96.1208 304.014 95.3719 304.014V304.014Z",
    fill: "#FFE492"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.235,
    y: 276.238,
    width: 81.2649,
    height: 81.2649,
    rx: 10,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.58 310.394H690.148V302.563C690.148 297.009 685.534 292.49 679.863 292.49C674.192 292.49 669.578 297.009 669.578 302.563V310.394H666.153C663.002 310.394 660.439 312.957 660.439 316.108V335.535C660.439 338.686 663.002 341.249 666.153 341.249H693.58C696.731 341.249 699.294 338.686 699.294 335.535V316.108C699.294 312.957 696.731 310.394 693.58 310.394ZM673.387 302.563C673.387 299.11 676.292 296.3 679.863 296.3C683.434 296.3 686.339 299.11 686.339 302.563V310.394H673.387V302.563V302.563ZM695.485 335.535C695.485 336.586 694.63 337.44 693.58 337.44H666.153C665.103 337.44 664.249 336.586 664.249 335.535V316.108C664.249 315.058 665.103 314.203 666.153 314.203H693.58C694.63 314.203 695.485 315.058 695.485 316.108V335.535Z",
    fill: "#4F9CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.867 319.727C677.921 319.727 676.344 321.304 676.344 323.25C676.344 324.493 676.987 325.585 677.959 326.212V330.393C677.959 331.445 678.812 332.297 679.864 332.297C680.915 332.297 681.768 331.445 681.768 330.393V326.216C682.744 325.59 683.391 324.496 683.391 323.25C683.391 321.304 681.813 319.727 679.867 319.727Z",
    fill: "#4F9CF9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.279,
    y: 35.6934,
    width: 81.2649,
    height: 81.2649,
    rx: 10,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.208 51.9463C562.381 51.9463 555.532 55.3589 555.532 58.4217C555.532 61.4846 562.381 64.8972 572.208 64.8972C582.035 64.8972 588.884 61.4845 588.884 58.4217C588.884 55.359 582.036 51.9463 572.208 51.9463Z",
    fill: "#FFE492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.532 88.1731V94.2296C555.532 97.2925 562.381 100.705 572.208 100.705C576.613 100.705 580.77 100.011 583.914 98.7516C585.964 97.9306 587.481 96.9123 588.27 95.8541C586.783 94.6905 585.066 93.0175 583.57 90.7093C580.277 91.7636 576.385 92.3169 572.208 92.3169C566.953 92.3169 562.037 91.4116 558.366 89.7677C557.295 89.2882 556.348 88.7538 555.532 88.1731V88.1731Z",
    fill: "#FFE492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.532 76.2646L555.532 82.2386C555.532 85.3013 562.381 88.7139 572.208 88.7139C575.693 88.7139 579.037 88.2769 581.839 87.4682C580.823 85.1194 580.166 82.5266 579.877 79.7209C577.48 80.1716 574.869 80.4069 572.208 80.4069C566.919 80.4069 561.98 79.4913 558.301 77.8288C557.257 77.3568 556.331 76.8328 555.532 76.2646V76.2646Z",
    fill: "#FFE492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.532 64.3508V70.3288C555.532 73.3915 562.381 76.8042 572.208 76.8042C574.837 76.8042 577.399 76.5566 579.705 76.0833C579.709 75.5171 579.878 74.0438 581.242 73.6694C583.391 73.0793 584.895 71.6628 585.028 69.7197C585.083 68.9198 586.084 67.7989 586.83 67.81H588.884V64.3508C588.085 64.919 587.16 65.4431 586.116 65.9156C582.432 67.5821 577.493 68.5 572.208 68.5C566.924 68.5 561.985 67.5821 558.301 65.9156C557.256 65.4431 556.331 64.919 555.532 64.3508V64.3508Z",
    fill: "#FFE492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.183 71.4131H588.435C587.834 73.9118 585.912 75.9616 583.313 76.8554C583.516 88.8494 590.41 93.4229 593.449 94.8568C593.623 94.9387 593.829 94.9299 594 94.8335C597.052 93.1141 603.97 87.9959 604.292 76.8513C601.699 75.9554 599.783 73.908 599.183 71.4131V71.4131ZM593.165 87.0323C592.435 87.7826 591.18 87.7414 590.501 86.945L587.076 82.9261L589.819 80.5895L591.96 83.102L597.934 76.9581L600.518 79.4693L593.165 87.0323Z",
    fill: "#FFE492"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.959,
    y: 35.6934,
    width: 81.2649,
    height: 81.2649,
    rx: 10,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.75 56.5421C211.623 50.4146 201.653 50.4147 195.525 56.5421C191.34 60.7272 189.887 66.8963 191.698 72.4919L174.006 90.1846C173.738 90.4525 173.587 90.8159 173.587 91.1948V99.2768C173.587 100.066 174.227 100.705 175.016 100.705H183.098C183.477 100.705 183.84 100.555 184.108 100.287L186.129 98.2661C186.438 97.9574 186.588 97.5245 186.538 97.0908L186.286 94.9212L189.293 94.6376C189.976 94.5733 190.517 94.0324 190.582 93.3494L190.865 90.3412L193.035 90.5934C193.44 90.6407 193.846 90.5124 194.15 90.2412C194.455 89.9702 194.629 89.582 194.629 89.1743V86.5137H197.241C197.617 86.5137 197.978 86.3654 198.246 86.101L201.795 82.5925C207.392 84.4067 213.564 82.9538 217.751 78.7674C223.878 72.6399 223.878 62.6696 217.75 56.5421ZM215.73 76.747C212.124 80.353 206.715 81.4785 201.95 79.6148C201.424 79.4092 200.826 79.5325 200.425 79.9293L196.654 83.6563H193.2C192.411 83.6563 191.772 84.296 191.772 85.085V87.5699L189.745 87.3344C189.363 87.2901 188.98 87.4013 188.681 87.643C188.382 87.8848 188.194 88.2367 188.158 88.6193L187.848 91.9038L184.564 92.2133C184.181 92.2494 183.829 92.4381 183.587 92.7368C183.345 93.0355 183.234 93.4191 183.278 93.8007L183.62 96.7343L182.506 97.8482H176.444V91.7868L194.357 73.8739C194.759 73.4726 194.884 72.8717 194.678 72.3432C192.814 67.578 193.94 62.1689 197.546 58.5628C202.559 53.5494 210.717 53.5494 215.73 58.5628C220.743 63.5761 220.743 71.7336 215.73 76.747Z",
    fill: "#4F9CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.709 60.583C212.037 58.9117 209.318 58.9118 207.647 60.583C205.976 62.2541 205.976 64.9733 207.647 66.6444C209.318 68.3156 212.037 68.3157 213.709 66.6444C215.38 64.9733 215.38 62.2541 213.709 60.583ZM211.688 64.624C211.131 65.181 210.225 65.1811 209.668 64.624C209.111 64.067 209.111 63.1606 209.668 62.6035C210.226 62.0451 211.13 62.0451 211.688 62.6035C212.247 63.162 212.246 64.0655 211.688 64.624Z",
    fill: "#4F9CF9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 382.438,
    cy: 17.0024,
    r: 13.0024,
    fill: "#A7CEFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.107,
    cy: 194.16,
    r: 13.0024,
    fill: "#A7CEFC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.846,
    cy: 316.87,
    r: 13.0024,
    fill: "#A7CEFC"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.5 300.18V309.262C364.5 312.028 367.954 313.503 370.065 311.567L380.141 302.485C382.348 300.503 380.908 297 377.886 297H367.81C365.987 297 364.5 298.429 364.5 300.18Z",
    fill: "#5986EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.19 297H402.114C399.14 297 397.652 300.503 399.859 302.485L409.935 311.567C412.046 313.457 415.5 312.028 415.5 309.262V300.18C415.5 298.429 414.013 297 412.19 297Z",
    fill: "#5986EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.279 319.173L409.935 335.124C412.046 337.014 415.5 335.585 415.5 332.819V323.645C415.5 322.769 415.116 321.939 414.444 321.34L392.279 301.287C390.984 300.134 389.016 300.134 387.721 301.287L365.556 321.34C364.884 321.939 364.5 322.769 364.5 323.645V332.819C364.5 335.585 367.954 337.06 370.065 335.124L387.721 319.173C389.016 318.021 390.984 318.021 392.279 319.173Z",
    fill: "#5986EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_711",
    x: 311.745,
    y: 241.238,
    width: 159.265,
    height: 159.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_711",
    x: 0.5,
    y: 241.238,
    width: 159.265,
    height: 159.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_711",
    x: 600.235,
    y: 241.238,
    width: 159.265,
    height: 159.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_711",
    x: 500.279,
    y: 0.693359,
    width: 159.265,
    height: 159.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_711",
    x: 119.959,
    y: 0.693359,
    width: 159.265,
    height: 159.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7589,
    height: 48.7589,
    fill: "white",
    transform: "translate(655.488 292.49)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7589,
    height: 48.7589,
    fill: "white",
    transform: "translate(555.532 51.9463)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7589,
    height: 48.7589,
    fill: "white",
    transform: "translate(173.587 51.9463)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 39,
    fill: "white",
    transform: "translate(364.5 297)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/numbers.ab7a6145310da6053f861aa3805c40ec.svg";
export { ForwardRef as ReactComponent };